export const SYSTEM_FONTS = [
  { name: 'Arial',           category: 'system' },
  { name: 'Helvetica',       category: 'system' },
  { name: 'Times New Roman', category: 'system' },
  { name: 'Georgia',         category: 'system' },
  { name: 'Courier New',     category: 'system' },
  { name: 'Verdana',         category: 'system' },
  { name: 'Impact',          category: 'system' },
  { name: 'Comic Sans MS',   category: 'system' },
  { name: 'Cause',           category: 'system' },
  { name: 'Cossette Texte',  category: 'system' },
  { name: 'Elms Sans',       category: 'system' },
];

export const GOOGLE_FONTS = [
  { name: 'Roboto',                category: 'sans-serif'  },
  { name: 'Open Sans',             category: 'sans-serif'  },
  { name: 'Lato',                  category: 'sans-serif'  },
  { name: 'Montserrat',            category: 'sans-serif'  },
  { name: 'Poppins',               category: 'sans-serif'  },
  { name: 'Nunito',                category: 'sans-serif'  },
  { name: 'Inter',                 category: 'sans-serif'  },
  { name: 'Raleway',               category: 'sans-serif'  },
  { name: 'Playfair Display',      category: 'serif'       },
  { name: 'Merriweather',          category: 'serif'       },
  { name: 'Lora',                  category: 'serif'       },
  { name: 'Oswald',                category: 'sans-serif'  },
  { name: 'Pacifico',              category: 'display'     },
  { name: 'Lobster',               category: 'display'     },
  { name: 'Dancing Script',        category: 'handwriting' },
  { name: 'Bebas Neue',            category: 'display'     },
  { name: 'Source Code Pro',       category: 'monospace'   },
  { name: 'Audiowide',             category: 'display'     },
  { name: 'Birthstone',            category: 'handwriting' },
  { name: 'Caveat Brush',          category: 'handwriting' },
  { name: 'EB Garamond',           category: 'serif'       },
  { name: 'Encode Sans Expanded',  category: 'sans-serif'  },
  { name: 'Fontdiner Swanky',      category: 'display'     },
  { name: 'Germania One',          category: 'display'     },
  { name: 'IM Fell Double Pica',   category: 'serif'       },
  { name: 'Indie Flower',          category: 'handwriting' },
  { name: 'Italianno',             category: 'handwriting' },
  { name: 'Limelight',             category: 'display'     },
  { name: 'Rye',                   category: 'display'     },
  { name: 'Stardos Stencil',       category: 'display'     },
];

export const ALL_FONTS = [...SYSTEM_FONTS, ...GOOGLE_FONTS];

/**
 * Injects a Google Fonts <link> tag for the given font family.
 * Safe to call multiple times — skips if already loaded.
 * System fonts are silently ignored.
 */
export const loadGoogleFont = (fontFamily) => {
  const isSystem = SYSTEM_FONTS.some(f => f.name === fontFamily);
  if (isSystem) return;

  const id = `gfont-${fontFamily.replace(/\s+/g, '-').toLowerCase()}`;
  if (document.getElementById(id)) return;

  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  const encoded = fontFamily.replace(/\s+/g, '+');
  link.href = `https://fonts.googleapis.com/css2?family=${encoded}:ital,wght@0,400;0,700;1,400&display=swap`;
  document.head.appendChild(link);
};
